import React from 'react';
import PopupServiceImg from 'Assets/layout/dashboard/popup-service.png';
import QuickButton from 'Douleutaras/components/QuickButton/QuickButton';
import DefaultModal from 'Douleutaras/components/modals/DefaultModal';
import { Trans } from 'react-i18next';
import Modal from 'Douleutaras/components/Modal/Modal';
import ModalSelectionItem from 'Douleutaras/components/modals/parts/ModalSelectionItem';
import { CCFModalOptions } from 'Douleutaras/types/index';
import { AllModalOptions, SelectionContactModalOptions } from 'Douleutaras/constants/ccf/need-help-options';
import { useExtractSellerInfoFromJob } from 'Douleutaras/hooks/bids/pros';

interface SelectionContactModalProps {
  isOpen: boolean;
  options: CCFModalOptions;
  jobId?: string;
  jobCategoryId?: string;
  title: string | React.ReactElement;
  showBackButton?: boolean;
  userMugshot?: string;
  onBack?(): void;
  setIsOpen(modalStatus): void;
  onNoProSelected?(userSelection): void;
  onProContactSelected?({ extraBidConversationId, extraBidSellerPhoneNumber, extraBidSellerName, optionSlug }:
                              { extraBidConversationId: string,
                                extraBidSellerPhoneNumber: string,
                                extraBidSellerName: string,
                                extraBidSellerId: string,
                                optionSlug: AllModalOptions
                              }): void;
}

/**
 * This modal is used to display a list of Pros, so the client can select them and then contact them
 */
export const SelectionContactModal = ({
  isOpen,
  setIsOpen,
  options,
  onBack,
  onNoProSelected,
  jobId,
  onProContactSelected,
  title,
  showBackButton,
  userMugshot
}: SelectionContactModalProps) => {
  const allJobSellerData = useExtractSellerInfoFromJob({ jobId });

  return (
    <Modal isOpen={isOpen} dismissCallback={() => setIsOpen(false)}>
      <DefaultModal
        serviceIcon={PopupServiceImg}
        serviceIconAlt={<Trans>T.CCF.SELECT CONTACT MODAL.IMAGE ALT TEXT</Trans>}
        title={title}
        backText={<Trans>T.CCF.SELECT CONTACT MODAL.BACK BUTTON TEXT</Trans>}
        backTextAriaLabel={<Trans>T.CCF.SELECT CONTACT MODAL.BACK BUTTON TEXT</Trans>}
        closeAriaLabel={<Trans>T.CCF.SELECT CONTACT MODAL.CLOSE ICON LABEL</Trans>}
        closeButtonCallback={() => setIsOpen(false)}
        backButtonCallback={typeof onBack === 'function' ? onBack : () => false}
        showBackButton={showBackButton}
        userMugshot={userMugshot}
      >
        <div>
          { options?.[SelectionContactModalOptions.WITH_PRO]?.active &&
            <>
              {allJobSellerData.map(jobSellerData => {
                const sellerName = jobSellerData.user.attributes.sellerDisplayName;

                return (
                  <ModalSelectionItem key={`key_user_id_${jobSellerData.user.id}`}>
                    <QuickButton
                      preview
                      title={sellerName}
                      onClick={() => onProContactSelected({
                        extraBidConversationId: jobSellerData.conversationId,
                        extraBidSellerPhoneNumber: jobSellerData.user.attributes.phone,
                        extraBidSellerName: jobSellerData.user.attributes.sellerDisplayName,
                        extraBidSellerId: jobSellerData.user.id,
                        optionSlug: SelectionContactModalOptions.WITH_PRO
                      })}
                      username={jobSellerData.user.attributes.username}
                      mugshot={jobSellerData.user.attributes.mugshot}
                    />
                  </ModalSelectionItem>
                );
              })}
            </>
          }
          { options?.[SelectionContactModalOptions.WITH_NONE]?.active &&
            <ModalSelectionItem>
              <QuickButton
                preview
                title={<Trans>T.CCF.SELECT CONTACT MODAL.NOONE</Trans>}
                onClick={() => onNoProSelected({
                  optionSlug: SelectionContactModalOptions.WITH_NONE,
                  modalSlug: options?.[SelectionContactModalOptions.WITH_NONE]?.modal,
                  modalOptions: options?.[SelectionContactModalOptions.WITH_NONE]?.modal_options
                }) }
              />
            </ModalSelectionItem>
          }
        </div>
      </DefaultModal>
    </Modal>
  );
};

export default SelectionContactModal;
